<template>
  <div :class="[$style.ModuleSwitch, $style[`ModuleSwitch--${theme}`]]">
    <span :class="$style.ModuleSwitch__Name">{{ name }} </span>
    <span
      :class="[$style.ModuleSwitch__BtnWrapper, $style[`ModuleSwitch__BtnWrapper--${mutatedShow ? 'show' : 'hide'}`]]"
      @click="handleChange"
      ><button :class="$style.ModuleSwitch__Btn"
    /></span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  emits: ['onChange'],
  props: {
    theme: { type: String, default: '' },
    name: { type: String, default: '' },
    show: { type: Boolean, default: true },
  },
  setup(props, context) {
    const mutatedShow = ref(props.show)

    const handleChange = function () {
      mutatedShow.value = !mutatedShow.value
      context.emit('onChange', mutatedShow.value)
    }

    watch(
      () => props.show,
      (val) => {
        mutatedShow.value = val
      }
    )

    return {
      mutatedShow,
      handleChange,
    }
  },
})
</script>

<style lang="less" module>
.ModuleSwitch {
  display: flex;
  padding: 6px 0;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;

  &--dark {
    --ModuleSwitch-text: #ffffff;
    --ModuleSwitch-Btn-background: #373d4e;
    --ModuleSwitch-Btn-background-effect: #13c2c2;
    --ModuleSwitch-Btn-text: #ffffff;
  }
  &--light {
    --ModuleSwitch-text: #1a1b1f;
    --ModuleSwitch-Btn-background: #e1e9ec;
    --ModuleSwitch-Btn-background-effect: #13c2c2;
    --ModuleSwitch-Btn-text: #ffffff;
  }

  &__Name {
    font-size: 14px;
    line-height: 24px;
    color: var(--ModuleSwitch-text);
  }

  &__BtnWrapper {
    padding: 1px;
    width: 28px;
    height: 16px;
    background-color: var(--ModuleSwitch-Btn-background);
    border-radius: 10px;
    box-sizing: border-box;
    display: flex;
    cursor: pointer;

    &--show {
      transition: background-color 0.25s ease;
      background-color: var(--ModuleSwitch-Btn-background-effect);
      .ModuleSwitch__Btn {
        transform: translateX(12px);
      }
    }
  }

  &__Btn {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    border: 0 none;
    cursor: pointer;
    background-color: var(--ModuleSwitch-Btn-text);
    transition: transform 0.25s ease;
  }
}
</style>
